module.exports = __webpack_public_path__ + "img/tick-circle-success.77dcfdf8.svg";